export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9298.35aec029.jpg";